import React from 'react';
import {
    Table,
    Space,
    Statistic
} from 'antd';
import EditFormModal from './EditFormModal';
import DeletePopupButton from './DeletePopupButton';

const columns = (products, formOrder, orderItems) => [
    {
        title: 'สินค้า',
        dataIndex: 'product',
        key: 'product',
        render: (_, record) => `${record.product?.description} ${record.product?.brand.name}`
    },
    {
        title: 'ราคา',
        dataIndex: 'price',
        key: 'price',
        render: (text, _) => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14 }} />
    },
    {
        title: 'จำนวน',
        dataIndex: 'quantity',
        key: 'quantity',
    },
    {
        title: 'ส่วนลด',
        dataIndex: 'discount',
        key: 'discount',
        render: (text, _) => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14 }} />
    },
    {
        title: 'รวม',
        dataIndex: 'total_price',
        key: 'total_price',
        render: (text, _) => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14 }} />
    },
    {
        title: '',
        dataIndex: 'action',
        key: 'action',
        render: (_, record) => (
            <Space size="middle">
                <EditFormModal data={record} formOrder={formOrder} productItems={orderItems} />
                <DeletePopupButton data={record} products={orderItems} formOrder={formOrder} />
            </Space>
        )
    },
];


function CartItems({ products, formOrder, orderItems }) {

    // console.log(products)

    return (
        <div>
            <Table
                rowKey={(record) => record._id}
                columns={columns(products, formOrder, orderItems)}
                dataSource={orderItems}
                pagination={false}
                scroll={{
                    x: 800,
                }}
            />
        </div>
    )
}

export default CartItems